import React from 'react'
import './BifrostContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'

export class BifrostContent extends React.Component {
  render() {
    return (
      <div className="bifrost-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            Bifrost is Rackner's open-source CI/CD catalog of customizable,
            reusable pipeline templates designed specifically for DoD software
            development environments - accelerating DevSecOps adoption across the
            Department of Defense.
          </div>
        </div>

        <section className="padding-large">
          <div className="row">
            <div className="col-md-6">
              <h2>The Challenge</h2>
              <p>
                The Department of Defense faces significant barriers to reusing
                best-in-class DevSecOps CI/CD pipelines: slow production times,
                knowledge silos, monetary barriers, and ensuring quality standards.
                Existing solutions like Platform One's Party Bus require onboarding
                for access and don't allow community contributions, while commercial
                alternatives don't focus on DoD security requirements.
              </p>
            </div>
            <div className="col-md-6">
              <h2>The Solution</h2>
              <p>
                Bifrost provides a catalog of reusable pipeline configurations
                leveraging GitLab/Repo1's CI/CD component feature. Each component
                can be customized using input parameters or combined to create
                larger pipelines. All components meet DoD security standards,
                operate predominantly offline, and use only Iron Bank hardened
                containers.
              </p>
            </div>
          </div>
        </section>

        <div className="split pattern">
          <h2>Publishing Standards</h2>
          <p className="intro-text">
            Every Bifrost CI/CD component must meet rigorous criteria to ensure
            quality, security, and maintainability:
          </p>
          <div className="row standards-grid">
            <div className="col-md-4">
              <div className="standard-card">
                <div className="title">Standard Format</div>
                <div className="description">
                  Follows Bifrost format for linting and includes sufficient
                  functional tests
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="standard-card">
                <div className="title">Offline Operation</div>
                <div className="description">
                  Operates predominantly offline to support disconnected DoD
                  environments
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="standard-card">
                <div className="title">Continuous Maintenance</div>
                <div className="description">
                  Established SLAs for vulnerability resolution and ongoing
                  support
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="standard-card">
                <div className="title">Iron Bank Containers</div>
                <div className="description">
                  Uses only hardened container images from Iron Bank for maximum
                  security
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="standard-card">
                <div className="title">Security Scans</div>
                <div className="description">
                  Passes all required security scans and compliance checks
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="standard-card">
                <div className="title">Modular Design</div>
                <div className="description">
                  Components can be combined and customized to fit specific
                  workflow needs
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="split">
          <h2>Platform One Integration</h2>
          <div className="text-wrap centered">
            <p>
              Bifrost integrates with the Platform One ecosystem of tools
              (Big Bang, Iron Bank, and Party Bus) as well as other DoD
              Software Factories leveraging GitLab CI/CD.
            </p>
          </div>
        </div>

        <div className="split light">
          <h2>Fast Acquisition</h2>
          <div className="text-wrap centered">
            <p>
              Bifrost is available for competitive or direct award on the
              Platform One Marketplace, enabling acquisition in as few as 30 days.
            </p>
          </div>
          <div className="marketplace-logos">
            <img src="/p1-marketplace.png" alt="Platform One Marketplace" />
          </div>
          <div className="button-wrap">
            <Link to="/contact">
              <button className="btn-raised-light-blue-inverse big">
                Learn More
              </button>
            </Link>
          </div>
        </div>

        <CallToActionBanner route={'insights'} linkText={'See Case Studies'} />
      </div>
    )
  }
}

export default BifrostContent
